// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.auth-wrapper {
  width: 100%;
  height: 100vh;
  padding: 26px 20px 17px 20px;
}

.gc-auth-leftPanel {
  height: 100%;
  background: url('login-banner.49de8a8e4c6bbf48.png') no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.gc-idnty-container {
  padding: 0 80px;
  margin-top: -100px;
}
.gc-idnty-container .portal-subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 20px;
  margin-bottom: 0;
}
.gc-idnty-container .portal-headline {
  margin-top: 48px;
}
.gc-idnty-container .portal-headline p {
  font-size: 42px;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.2;
  margin: 0;
  letter-spacing: -0.5px;
}
.gc-idnty-container .portal-headline .portal-highlight {
  color: #6ACE6A;
  font-style: italic;
}

.password-check {
  height: 4px;
  width: 100px;
  background-color: #ccc;
}

.password-strength-container {
  display: flex;
  justify-content: flex-end;
}

.weak-password {
  background-color: #FF6B6B; /* Red color */
}

.medium-password {
  background-color: #FEBD2E; /* Yellow color */
}

.strong-password {
  background-color: #66DE93; /* Green color */
}

/* Weak Password Text Style */
.weak-password-text {
  color: #FF6B6B; /* Red color */
  margin: -15px 0 0 0;
}

/* Medium Password Text Style */
.medium-password-text {
  color: #FEBD2E;
  margin: -12px; /* Yellow color */
}

/* Strong Password Text Style */
.strong-password-text {
  color: #66DE93; /* Green color */
  margin: -15px 0 0 0;
}

.gc-auth-slider {
  padding: 0 56px;
  margin-top: 60px;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/login/forgot-password/create-new-password/create-new-password.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,WAAA;EACA,aAAA;EACA,4BAAA;AAGF;;AADA;EACI,YAAA;EACA,4EAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAIJ;;AAFA;EACE,eAAA;EACA,kBAAA;AAKF;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AAMJ;AAJE;EACE,gBAAA;AAMJ;AALI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;AAON;AALI;EACE,cAAA;EACA,kBAAA;AAON;;AAHA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAMF;;AAJA;EACE,aAAA;EACA,yBAAA;AAOF;;AALA;EACE,yBAAA,EAAA,cAAA;AAQF;;AALA;EACE,yBAAA,EAAA,iBAAA;AAQF;;AALA;EACE,yBAAA,EAAA,gBAAA;AAQF;;AAJA,6BAAA;AACA;EACE,cAAA,EAAA,cAAA;EACA,mBAAA;AAOF;;AAJA,+BAAA;AACA;EACE,cAAA;EACA,aAAA,EAAA,iBAAA;AAOF;;AAJA,+BAAA;AACA;EACE,cAAA,EAAA,gBAAA;EACA,mBAAA;AAOF;;AALA;EACE,eAAA;EACA,gBAAA;AAQF;;AANA;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AASF;AARE;EALF;IAMI,iBAAA;EAWF;AACF","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../../../assets/styles/colors.scss\";\n.auth-wrapper {\n  width: 100%;\n  height: 100vh;\n  padding: 26px 20px 17px 20px;\n}\n.gc-auth-leftPanel {\n    height: 100%;\n    background: url(../../../../assets/images/login-banner.png) no-repeat center center;\n    background-size: cover;\n    border-radius: 16px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n.gc-idnty-container{\n  padding: 0 80px;\n  margin-top: -100px;\n  .portal-subtitle {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 20px;\n    letter-spacing: 2.5px;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.65);\n    margin-top: 20px;\n    margin-bottom: 0;\n  }\n  .portal-headline {\n    margin-top: 48px;\n    p {\n      font-size: 42px;\n      font-weight: 500;\n      color: #ffffff;\n      line-height: 1.2;\n      margin: 0;\n      letter-spacing: -0.5px;\n    }\n    .portal-highlight {\n      color: #6ACE6A;\n      font-style: italic;\n    }\n  }\n}\n.password-check{\n  height: 4px;\n  width: 100px;\n  background-color: #ccc;\n}\n.password-strength-container {\n  display: flex;\n  justify-content: flex-end;\n}\n.weak-password {\n  background-color: #FF6B6B; /* Red color */\n}\n\n.medium-password {\n  background-color: #FEBD2E; /* Yellow color */\n}\n\n.strong-password {\n  background-color: #66DE93; /* Green color */\n}\n\n\n/* Weak Password Text Style */\n.weak-password-text {\n  color: #FF6B6B; /* Red color */\n  margin: -15px 0 0 0;\n}\n\n/* Medium Password Text Style */\n.medium-password-text {\n  color: #FEBD2E;\n  margin: -12px; /* Yellow color */\n}\n\n/* Strong Password Text Style */\n.strong-password-text {\n  color: #66DE93; /* Green color */\n  margin: -15px 0 0 0;\n}\n.gc-auth-slider{\n  padding: 0 56px;\n  margin-top: 60px;\n}\n.password-req{\n  font-size: 12px;\n  margin-top: 8px;\n  display: inline-block;\n  line-height: 28px;\n  @media (max-width:1640px) {\n    line-height: 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
